export const removeWhitespaceCharacters = (value) => value.replaceAll(/\s/g, '');
